import type { AtLeast } from '#layers/base/public';
import type { BlockSerializedChild, BlockSerializedSlotOutlet } from '#layers/block-engine/public';
import type { MonospaceBlock, MonospacePage } from '#layers/data-model/public';
import { blockRenderDataFactory } from './block-render-data-factory';

type SpacePageFactoryInput = AtLeast<MonospacePage, 'id' | 'title' | 'route' | 'spaceId'> & {
	block?: AtLeast<Omit<NonNullable<MonospaceBlock['renderData']>, 'children'>, 'rootChildren'> & {
		children: Record<string, AtLeast<Omit<BlockSerializedChild, 'id'>, 'blockId'> | AtLeast<Omit<BlockSerializedSlotOutlet, 'id'>, 'slotName'>>;
	};
};

/**
 * Creates a generated space page and its optional transient page block.
 */
export function spacePageFactory(page: SpacePageFactoryInput): MonospacePage & {
	block: MonospaceBlock | undefined;
} {
	return {
		icon: 'lucide:file',
		iconColor: null,
		sort: 0,
		description: null,
		isFullWidth: false,
		isHidden: false,
		sectionId: null,
		type: null,
		intent: null,
		collectionId: null,
		parentPageId: null,
		overridePage: null,
		...page,
		block: page.block
			? {
					id: `${page.id}:block`,
					category: 'page',
					pageId: page.id,
					spaceId: null,
					description: null,
					collectionId: null,
					pageIntent: null,
					pageType: null,
					icon: null,
					name: 'page-details',
					renderData: blockRenderDataFactory(page.block),
				}
			: undefined,
	};
}
